import { apiStaticUrlGet } from "common/api/api_common";
import { formatDate } from "common/util/date/date_common";
import { UnitFieldValName } from "constant/dl_unit/dl_unit_field.constant";
import { UNIT_TYPES } from "constant/dl_unit/unit_type.constant";
import ObjCommon from "model/common/ObjCommon";
import { UnitFVals } from "type/dl_unit/dl_unit.type";

type DLUnitPdf = {
  fold: string;
  nam: string;
};

const DEFAULT_UNIT_PDF = {
  fold: "",
  nam: "",
};

export class DlUnit extends ObjCommon {
  slug: string = "";
  uType: string = "";
  uDate: Date | null = null;
  num: number = 0;
  fold: string = "";
  fVals: UnitFVals = {};
  scans: any[] = [];
  pdf: DLUnitPdf = { ...DEFAULT_UNIT_PDF };

  //   constructor(id: any) {
  //     super(id);
  //   }

  constructor(args: Partial<DlUnit> = {}) {
    super(args?.id); // Call ObjCommon's constructor, passing id if present

    this.slug = args?.slug ?? "";
    this.uType = args?.uType ?? "";
    this.uDate = args?.uDate ? new Date(args.uDate) : null;
    this.num = args?.num ?? 0;
    this.fold = args?.fold ?? "";
    this.fVals = args?.fVals ? { ...args.fVals } : {};
    this.scans = args?.scans ? [...args.scans] : [];
    this.pdf = args?.pdf ?? { ...DEFAULT_UNIT_PDF };
  }

  fValGet(fNam: string): string {
    let fVal = "";
    if (Object.prototype.hasOwnProperty.call(this.fVals, fNam)) {
      fVal = this.fVals[fNam];
    }
    return fVal;
  }

  unitTitleGet(): string {
    let title = "";
    title += this.fValGet("200_a");
    if (title !== "") {
      const f200e = this.fValGet("200_e");
      title += (f200e !== "" ? ", " : "") + f200e;
    }
    return title;
  }

  unitEditTitleGet(): string {
    let title = this.unitTitleGet();
    if (!title) {
      title = this.slug;
    }
    return title;
  }

  isTypeHM2(): boolean {
    return this.uType === UNIT_TYPES.HM2;
  }

  pdfFileNameGet(): string {
    let pdfFileName: string = "";
    if (this.pdf && this.pdf.nam) {
      pdfFileName = this.pdf.nam;
    }
    return pdfFileName;
  }

  pdfFoldGet(): string {
    let pdfFold: string = "";
    if (this.pdf && this.pdf.fold) {
      pdfFold = this.pdf.fold;
    }
    return pdfFold;
  }

  getPdfStaticUrl(pdfOverride: DLUnitPdf = { ...DEFAULT_UNIT_PDF }): string {
    let url: string = "";
    let fold: string = "";
    let nam: string = "";
    if (pdfOverride.fold && pdfOverride.nam) {
      fold = pdfOverride.fold;
      nam = pdfOverride.nam;
    } else if (this.pdf && this.pdf.fold && this.pdf.nam) {
      fold = this.pdf.fold;
      nam = this.pdf.nam;
    }

    if (fold && nam) {
      url = apiStaticUrlGet(`dl-unit/mat/${fold}/${nam}`);
    }

    return url;
  }

  formatUDate(): string {
    if (!this.uDate) {
      return "";
    }
    return formatDate(this.uDate);
  }
}
